module.exports = __webpack_public_path__ + "img/2.b7168f05.jpg";